<template>
    <div class="item okraina-a-cb col-12 col-sm-12 col-md-6 col-lg-4">
        <div class="okraina-block double">
            <div class="block-title name" v-html="params.NAME"></div>
            <div class="block-description description" v-html="params.DESCRIPTION"></div>

            <div class="value">

                <a class="value1" :href="'tel:' + params.PHONE" target="_blank">{{ params.PHONE }}</a><br />
                <a class="value1" :href="'mailto:' + params.EMAIL" target="_blank">{{ params.EMAIL }}</a>
            </div>

        </div>


    </div>
</template>

<script>

export default {
    name: "okraina-about-contacts-block-phone",
    props: {
        params: {
            type: Object,
            default() {
                return {};
            },
        },

    },
}
</script>

<style lang="scss"></style>